/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-continue */
import _ from 'lodash';
import moment from 'moment';
import _foodkidApis from '@app/apis/foodkid/foodkid';
import { REPORT_TYPE } from '@app/constants/index';
import { numberToPrice } from '@app/utils/utils';

import _menuExportPDFService from './_exportMenu';
import _marketExportPDFService from './_exportPhieuKeCho';
import _setupMarketExportPDFService from './_exportSoTinhTienCho';
import _supplierExportPDFService from './_exportPhieuTiepPham';
import _stepExportPDFService from './_exportSoKiemThuc';
import _syntheticNutritionWeekExportPDFService from './_exportTongHopTuan';
import _receiptInExportPDFService from './_exportPhieuNhapXuatKho';
import _receiptExportPDFService from './_exportTheKho';
import _receiptTotalExportPDFService from './_exportTongHopTheKho';
import _billOfSaleExportPDFService from './_exportBillOfSale';
import _weeklyMenuExportPDFService from './_exportThucDonTuan';
import {
    groupBySchoolFood,
    groupMenusByDate,
    filterByKidGroup,
    getDaysArray,
    showWeeks,
} from './reportHelpers';
import { formatDateUnix } from '@app/utils/datetime.utils';

// ────────────────────────────────────────────
// Thực đơn trong ngày / Sổ trẻ thực ăn
// ────────────────────────────────────────────
export const handleThucDonTrongNgay = async (code, ctx) => {
    const {
        menulist,
        proFoods,
        menuSchoolFoods,
        schoolFoods,
        menudishs,
        menuServices,
    } = ctx.refs;
    const {
        units,
        kidGroup,
        ageGroup,
        locationInfo,
        schoolInfo,
        organizationInfo,
        mealService,
    } = ctx;

    if (menulist.length === 0) return true;

    const nameFile = code === 'thuc_don_trong_ngay' ? 'TDN' : 'TAN';

    for (const menu of menulist) {
        const reportTitle =
            code === 'thuc_don_trong_ngay'
                ? 'KẾT QUẢ KHẨU PHẦN DINH DƯỠNG'
                : `SỔ TRẺ THỰC ĂN TRONG NGÀY (${moment
                      .unix(menu.m_datefounded)
                      .format('DD-MM-YYYY')})`;

        await _menuExportPDFService.doExportMenu(
            proFoods,
            schoolFoods,
            menuSchoolFoods?.filter((o) => o.m_id === menu.m_id),
            units,
            menu,
            kidGroup,
            menudishs?.filter((o) => o.m_id === menu.m_id),
            ageGroup,
            menuServices?.filter((o) => o.m_id === menu.m_id),
            locationInfo,
            schoolInfo,
            organizationInfo,
            mealService,
            nameFile,
            reportTitle,
        );
    }

    return true;
};

// ────────────────────────────────────────────
// Phiếu kê chợ
// ────────────────────────────────────────────
export const handlePhieuKeCho = async (code, ctx) => {
    const { menulist, proFoods, menuSchoolFoods, schoolFoods } = ctx.refs;
    const {
        units,
        kidGroup,
        locationInfo,
        schoolInfo,
        organizationInfo,
        decimalRound,
    } = ctx;

    if (menulist.length === 0) return true;

    const isShowSign = code !== 'phieu_ke_cho_khong_chu_ky';
    const menus = groupMenusByDate(menulist);

    for (const menu of menus) {
        await _marketExportPDFService.doExport({
            proFoods,
            schoolFoods,
            menuSchoolFoods: menuSchoolFoods?.filter((o) =>
                menu.ids.find((x) => x === o.m_id),
            ),
            units,
            menulist: menu.datas,
            kidGroup,
            locationInfo,
            schoolInfo,
            organizationInfo,
            dataValue: 1,
            nameFile: 'PKC',
            isShowSign,
            decimalRound,
        });
    }

    return true;
};

// ────────────────────────────────────────────
// Phiếu tiếp phẩm
// ────────────────────────────────────────────
export const handlePhieuTiepPham = async (ctx) => {
    const { menulist, menuSchoolFoods, schoolFoods } = ctx.refs;
    const { units, locationInfo, schoolInfo, organizationInfo } = ctx;

    if (menulist.length === 0) return true;

    const menus = groupMenusByDate(menulist);

    for (const menu of menus) {
        await _supplierExportPDFService.doExport(
            schoolFoods,
            menuSchoolFoods?.filter((o) => menu.ids.find((x) => x === o.m_id)),
            units,
            menu.datas,
            locationInfo,
            schoolInfo,
            organizationInfo,
            1,
            'PTP',
        );
    }

    return true;
};

// ────────────────────────────────────────────
// Sổ kiểm thực
// ────────────────────────────────────────────
export const handleSoKiemThuc = async (code, ctx) => {
    const { menulist, menuSchoolFoods, schoolFoods, menudishs } = ctx.refs;
    const {
        units,
        locationInfo,
        schoolInfo,
        organizationInfo,
        supplier,
        dish,
        packaging,
    } = ctx;

    if (menulist.length === 0) return true;

    const menus = groupMenusByDate(menulist);

    for (const menu of menus) {
        await _stepExportPDFService.doExport(
            menudishs.filter((o) => menu.datas.find((x) => x.m_id === o.m_id)),
            schoolFoods,
            menuSchoolFoods?.filter((o) => menu.ids.find((x) => x === o.m_id)),
            units,
            menu.datas,
            locationInfo,
            schoolInfo,
            organizationInfo,
            supplier,
            dish,
            packaging,
            'TP3B',
            code,
        );
    }

    return true;
};

// ────────────────────────────────────────────
// Bảng tổng hợp khẩu phần dinh dưỡng tuần
// ────────────────────────────────────────────
export const handleTongHopDinhDuongTuan = async (ctx) => {
    const { menulist, proFoods, menuSchoolFoods, schoolFoods, menudishs } =
        ctx.refs;
    const {
        dateFrom,
        dateTo,
        kidGroup,
        dish,
        locationInfo,
        schoolInfo,
        organizationInfo,
    } = ctx;

    if (menulist.length === 0) return true;

    const dates = showWeeks(dateFrom, dateTo);

    for (const date of dates) {
        const check = menulist.filter(
            (o) => o.m_datefounded <= date.end && o.m_datefounded >= date.start,
        );

        if (check.length > 0) {
            for (const kg of kidGroup) {
                const ids = check
                    .filter((o) => o.kg_id === kg.kg_id)
                    .map((o) => o.m_id);

                await _syntheticNutritionWeekExportPDFService.doExport(
                    proFoods,
                    schoolFoods,
                    menuSchoolFoods?.filter((o) =>
                        ids.find((x) => x === o.m_id),
                    ),
                    menulist.filter(
                        (o) =>
                            o.m_datefounded <= date.end &&
                            o.m_datefounded >= date.start &&
                            o.kg_id === kg.kg_id,
                    ),
                    menudishs?.filter((o) => ids.find((x) => x === o.m_id)),
                    dish,
                    kg,
                    locationInfo,
                    schoolInfo,
                    organizationInfo,
                    1,
                    date.start,
                    date.end,
                );
            }
        }
    }

    return true;
};

// ────────────────────────────────────────────
// Thực đơn tuần
// ────────────────────────────────────────────
export const handleThucDonTuan = async (ctx) => {
    const { menulist, menudishs } = ctx.refs;
    const {
        dateFrom,
        dateTo,
        kidGroupIds,
        dish,
        locationInfo,
        schoolInfo,
        organizationInfo,
    } = ctx;

    if (menulist.length === 0) return true;

    const dates = showWeeks(dateFrom, dateTo);
    const kidGroupIdSet = new Set(kidGroupIds);

    for (const date of dates) {
        const check = menulist.filter(
            (o) => o.m_datefounded <= date.end && o.m_datefounded >= date.start,
        );

        if (check.length > 0) {
            const ids = check
                .filter((o) => kidGroupIdSet.has(o.kg_id))
                .map((o) => o.m_id);

            await _weeklyMenuExportPDFService.doExport(
                menulist.filter(
                    (o) =>
                        o.m_datefounded <= date.end &&
                        o.m_datefounded >= date.start &&
                        kidGroupIdSet.has(o.kg_id),
                ),
                menudishs?.filter((o) => ids.find((x) => x === o.m_id)),
                dish,
                locationInfo,
                schoolInfo,
                organizationInfo,
                1,
                date.start,
                date.end,
                'TDT',
            );
        }
    }

    return true;
};

// ────────────────────────────────────────────
// Sổ tính tiền chợ
// ────────────────────────────────────────────
export const handleSoTinhTienCho = async (ctx) => {
    const { schoolFoods } = ctx.refs;
    const {
        oId,
        dateFrom,
        dateTo,
        kidGroupIdSet,
        kidGroup,
        units,
        locationInfo,
        schoolInfo,
        organizationInfo,
        decimalRound,
    } = ctx;

    const dataArr = getDaysArray(
        moment.unix(dateFrom).year(),
        moment.unix(dateFrom).month(),
        moment.unix(dateFrom).date(),
        moment.unix(dateTo).date(),
    );

    for (const date of dataArr) {
        const { status, data } = await _foodkidApis.getMarketCashBook({
            oId,
            dateFound: date,
        });

        if (status !== 200 || !data.data.list?.length) continue;

        const menus = filterByKidGroup(kidGroupIdSet, data.data.menus);
        const marketMenuSchoolFoods = filterByKidGroup(
            kidGroupIdSet,
            data.data.list,
        );

        await _setupMarketExportPDFService.doExport({
            schoolFoods,
            menuSchoolFoods: groupBySchoolFood(marketMenuSchoolFoods, false),
            listwarehouse: groupBySchoolFood(marketMenuSchoolFoods, true),
            difference: filterByKidGroup(kidGroupIdSet, data.data.difference),
            difference_start_month: filterByKidGroup(
                kidGroupIdSet,
                data.data.difference_start_month,
            ),
            report: filterByKidGroup(kidGroupIdSet, data.data.report),
            service_report: filterByKidGroup(
                kidGroupIdSet,
                data.data.service_report,
            ),
            services: filterByKidGroup(kidGroupIdSet, data.data.services),
            units,
            menulist: menus,
            kidGroup,
            locationInfo,
            schoolInfo,
            organizationInfo,
            date,
            nameFile: 'STTC',
            type: REPORT_TYPE.SO_TINH_TIEN_CHO,
            decimalRound,
        });
    }

    return true;
};

// ────────────────────────────────────────────
// Phiếu nhập kho
// ────────────────────────────────────────────
export const handlePhieuNhapKho = async (ctx) => {
    const { schoolFoods } = ctx.refs;
    const {
        oId,
        dateFrom,
        dateTo,
        units,
        inventories,
        schoolInfo,
        organizationInfo,
    } = ctx;

    const { status, data } = await _foodkidApis.getListImportVoucher({
        o_id: oId,
        id: -1,
        dateFrom,
        dateTo,
        typeGetData: 1,
    });

    if (status === 200 && data.data.length > 0) {
        for (const item of data.data) {
            await _receiptInExportPDFService.doExport(
                schoolFoods,
                item,
                units,
                inventories,
                schoolInfo,
                organizationInfo,
                1,
                'PNK',
            );
        }
    }
    return true;
};

// ────────────────────────────────────────────
// Phiếu xuất kho
// ────────────────────────────────────────────
export const handlePhieuXuatKho = async (ctx) => {
    const { schoolFoods } = ctx.refs;
    const {
        oId,
        dateFrom,
        dateTo,
        units,
        inventories,
        schoolInfo,
        organizationInfo,
    } = ctx;

    const { status, data } = await _foodkidApis.getListExportVoucher({
        o_id: oId,
        id: -1,
        dateFrom,
        dateTo,
        typeGetData: 1,
    });

    if (status === 200 && data.data.length > 0) {
        for (const item of data.data) {
            await _receiptInExportPDFService.doExport(
                schoolFoods,
                item,
                units,
                inventories,
                schoolInfo,
                organizationInfo,
                2,
                'PXK',
            );
        }
    }
    return true;
};

// ────────────────────────────────────────────
// Thẻ kho
// ────────────────────────────────────────────
export const handleTheKho = async (ctx) => {
    const { schoolFoods } = ctx.refs;
    const {
        oId,
        dateFrom,
        dateTo,
        units,
        inventories,
        locationInfo,
        schoolInfo,
        organizationInfo,
    } = ctx;

    const { status, data } = await _foodkidApis.getListWarehouseCard({
        o_id: oId,
        dateFrom,
        dateTo,
        typeGetData: 1,
    });
    const dataApi = data.data;

    if (status !== 200 || !dataApi.list?.length) {
        return true;
    }

    for (const inventory of inventories) {
        const datas = dataApi.list.filter((o) => o.w_id === inventory.w_id);
        if (datas.length === 0) continue;

        const receipts = _.chain(datas)
            .groupBy('sf_id')
            .map((value, key) => ({
                sf_id: key,
                datas: value,
            }))
            .value();

        for (const item of receipts) {
            const beforeInfo = dataApi.listBefore.find(
                (o) =>
                    o.sf_id === parseInt(item.sf_id) &&
                    o.w_id === inventory.w_id,
            );

            await _receiptExportPDFService.doExport(
                item.datas,
                beforeInfo?.soLuongTon || 0,
                beforeInfo?.tongTienTon || 0,
                schoolFoods,
                units,
                item.sf_id,
                moment.unix(dateFrom).year(),
                moment.unix(dateFrom).month() + 1,
                inventory,
                locationInfo,
                schoolInfo,
                organizationInfo,
            );
        }
    }

    return true;
};

// ────────────────────────────────────────────
// Tổng hợp thẻ kho
// ────────────────────────────────────────────
export const handleTongHopTheKho = async (ctx) => {
    const { schoolFoods } = ctx.refs;
    const {
        oId,
        dateFrom,
        dateTo,
        inventories,
        locationInfo,
        schoolInfo,
        organizationInfo,
    } = ctx;

    const { status, data } = await _foodkidApis.getSummaryWarehouseCard({
        o_id: oId,
        dateFrom,
        dateTo,
        typeGetData: 1,
    });

    if (status === 200) {
        const dataApi = data.data;
        if (dataApi.list?.length) {
            for (const inventory of inventories) {
                const foodReceiptTotalList = dataApi.list.filter(
                    (o) => o.w_id === inventory.w_id,
                );
                const foodReceiptBeforeList = dataApi.dataBefore.filter(
                    (o) => o.w_id === inventory.w_id,
                );
                if (foodReceiptTotalList.length > 0) {
                    await _receiptTotalExportPDFService.doExport(
                        foodReceiptTotalList,
                        moment.unix(dateFrom).year(),
                        moment.unix(dateFrom).month() + 1,
                        foodReceiptBeforeList,
                        locationInfo,
                        schoolInfo,
                        organizationInfo,
                        inventory,
                        schoolFoods,
                    );
                }
            }
        }
    }
    return true;
};

// ────────────────────────────────────────────
// Hóa đơn bán hàng
// ────────────────────────────────────────────
export const handleHoaDonBanHang = async (ctx) => {
    const { menulist, menuSchoolFoods, schoolFoods } = ctx.refs;
    const {
        units,
        locationInfo,
        schoolInfo,
        organizationInfo,
        supplier,
        invoiceForm,
    } = ctx;

    if (!schoolInfo?.hoa_don_nha_cung_cap || menulist.length === 0) return true;

    const menuGroupBy = groupMenusByDate(menulist);

    const _menu = menuGroupBy.map((item) => {
        const listMenuSchoolFood = _.chain(menuSchoolFoods ?? [])
            .map((o) => {
                const objSF =
                    schoolFoods?.find((x) => x.sf_id === o.sf_id) ?? {};
                return {
                    ...o,
                    s_id: o.s_id ? o.s_id : objSF.s_id,
                    sf_price: numberToPrice(objSF.sf_price),
                    sf_isexportinvoice: objSF.sf_isexportinvoice,
                    sf_name: objSF.sf_name,
                };
            })
            ?.filter(
                (o) =>
                    item.ids.includes(o.m_id) &&
                    !o.msf_useinwarehouse &&
                    o.sf_isexportinvoice,
            )
            .groupBy('s_id')
            .map((value, key) => ({
                s_id: key,
                data: value,
            }))
            .value();

        return {
            m_datefounded: item.m_datefounded,
            dateFormatView: formatDateUnix(item.m_datefounded),
            dataSchoolFood: listMenuSchoolFood,
        };
    });

    for (const menu of _menu) {
        for (const dataSchoolFood of menu.dataSchoolFood) {
            const groupByQuantity = _.chain(dataSchoolFood.data)
                .groupBy('sf_id', 'msf_priceafter')
                .map((value) => ({
                    ...value[0],
                    quantity: value
                        .reduce((a, b) => a + b.msf_totalquantityafter, 0)
                        .toFixed(2),
                }))
                .value();

            await _billOfSaleExportPDFService.doExportBillOfSale(
                dataSchoolFood.s_id,
                groupByQuantity,
                units,
                menu.m_datefounded,
                locationInfo,
                organizationInfo,
                schoolInfo,
                supplier,
                invoiceForm,
                2,
                'HDBH',
            );
        }
    }

    return true;
};

// ────────────────────────────────────────────
// Bảng công khai tài chính
// ────────────────────────────────────────────
export const handleBangCongKhaiTaiChinh = async (ctx) => {
    const { schoolFoods } = ctx.refs;
    const {
        oId,
        dateFrom,
        dateTo,
        kidGroupIdSet,
        kidGroup,
        units,
        locationInfo,
        schoolInfo,
        organizationInfo,
        decimalRound,
    } = ctx;

    const daysArray = getDaysArray(
        moment.unix(dateFrom).year(),
        moment.unix(dateFrom).month(),
        moment.unix(dateFrom).date(),
        moment.unix(dateTo).date(),
    );

    for (const date of daysArray) {
        const { status, data } = await _foodkidApis.getMarketCashBook({
            oId,
            dateFound: date,
        });

        if (status !== 200 || !data.data.list?.length) {
            continue;
        }

        const menus = filterByKidGroup(kidGroupIdSet, data.data.menus);
        const marketMenuSchoolFoods = filterByKidGroup(
            kidGroupIdSet,
            data.data.list,
        );

        await _setupMarketExportPDFService.doExport({
            schoolFoods,
            menuSchoolFoods: groupBySchoolFood(marketMenuSchoolFoods, false),
            listwarehouse: groupBySchoolFood(marketMenuSchoolFoods, true),
            difference: filterByKidGroup(kidGroupIdSet, data.data.difference),
            difference_start_month: filterByKidGroup(
                kidGroupIdSet,
                data.data.difference_start_month,
            ),
            report: filterByKidGroup(kidGroupIdSet, data.data.report),
            service_report: filterByKidGroup(
                kidGroupIdSet,
                data.data.service_report,
            ),
            services: filterByKidGroup(kidGroupIdSet, data.data.services),
            units,
            menulist: menus,
            kidGroup,
            locationInfo,
            schoolInfo,
            organizationInfo,
            date,
            nameFile: 'BangCongKhaiTaiChinh',
            type: REPORT_TYPE.BANG_CONG_KHAI_TAI_CHINH,
            decimalRound,
        });
    }

    return true;
};

// ────────────────────────────────────────────
// Dispatcher — maps report code → handler
// ────────────────────────────────────────────
const HANDLER_MAP = {
    thuc_don_trong_ngay: (ctx) =>
        handleThucDonTrongNgay('thuc_don_trong_ngay', ctx),
    service_so_tre_thuc_an: (ctx) =>
        handleThucDonTrongNgay('service_so_tre_thuc_an', ctx),
    phieu_ke_cho: (ctx) => handlePhieuKeCho('phieu_ke_cho', ctx),
    phieu_ke_cho_khong_chu_ky: (ctx) =>
        handlePhieuKeCho('phieu_ke_cho_khong_chu_ky', ctx),
    phieu_tiep_pham: (ctx) => handlePhieuTiepPham(ctx),
    so_kiem_thuc: (ctx) => handleSoKiemThuc('so_kiem_thuc', ctx),
    so_kiem_thuc_trong: (ctx) => handleSoKiemThuc('so_kiem_thuc_trong', ctx),
    service_so_kiem_thuc_mau_1: (ctx) =>
        handleSoKiemThuc('service_so_kiem_thuc_mau_1', ctx),
    service_so_kiem_thuc_mau_2: (ctx) =>
        handleSoKiemThuc('service_so_kiem_thuc_mau_2', ctx),
    bang_tong_hop_khau_phan_dinh_duong_tuan: (ctx) =>
        handleTongHopDinhDuongTuan(ctx),
    thuc_don_tuan: (ctx) => handleThucDonTuan(ctx),
    so_tinh_tien_cho: (ctx) => handleSoTinhTienCho(ctx),
    phieu_nhap_kho: (ctx) => handlePhieuNhapKho(ctx),
    phieu_xuat_kho: (ctx) => handlePhieuXuatKho(ctx),
    the_kho: (ctx) => handleTheKho(ctx),
    tong_hop_the_kho: (ctx) => handleTongHopTheKho(ctx),
    hoa_don_ban_hang: (ctx) => handleHoaDonBanHang(ctx),
    bang_cong_khai_tai_chinh: (ctx) => handleBangCongKhaiTaiChinh(ctx),
};

/**
 * Dispatch report theo code.
 * @returns {boolean} isDone
 */
export const dispatchReport = async (code, ctx) => {
    const handler = HANDLER_MAP[code];
    if (handler) {
        return handler(ctx);
    }
    return true; // unknown code → skip
};
